module.exports = __webpack_public_path__ + "img/icon-envelope-light.54c12ed4.svg";